import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from "@angular/router";

import { forkJoin, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthService } from "../services";

@Injectable({ providedIn: "root" })
export class MustBeUserProfile implements CanActivate {
	constructor(private router: Router, private _authService: AuthService) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> {
		return forkJoin({
			userRoles: this._authService.getUserRoles().pipe(
				catchError((err) => {
					console.error("[MustBeUserProfile] getUserRoles failed", err);
					return of(null);
				})
			),
			personCompanyProfile: this._authService.getPersonCompanyProfile().pipe(
				catchError((err) => {
					console.error("[MustBeUserProfile] getPersonCompanyProfile failed", err);
					return of(null);
				})
			),
		}).pipe(
			catchError(() => of(true)),
			map(() => true)
		);
	}
}
